import TextField from '@base/TextField/TextField';
import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import Button from 'aquilla/core/molecules/Button';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_6B};
  width: 100%;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_2B};
  width: 100%;
`;

export const FieldLabel = styled(Typography)`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.H6};
  line-height: ${Spacings.SPACING_6B};
  color: var(--color-text-primary);

  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.ULTRA_SMALL};
    line-height: ${Spacings.SPACING_4B};
  }
`;

export const FieldLabelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${Spacings.SPACING_2B};
`;

export const HelperText = styled(Typography)`
  font-size: ${Fonts.ULTRA_SMALL};
  line-height: ${Spacings.SPACING_4B};
  color: var(--color-text-secondary);
`;

export const StyledTextField = styled(TextField)`
  width: 100%;
  border-radius: ${Spacings.SPACING_2B};
`;

export const NameFieldWrapper = styled.div`
  width: 100%;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'auto')};

  .MuiOutlinedInput-root {
    pointer-events: ${({ $isDisabled }) => ($isDisabled ? 'none' : 'auto')};
  }

  .MuiOutlinedInput-input.Mui-disabled {
    color: var(--color-text-secondary);
    -webkit-text-fill-color: var(--color-text-secondary);
  }
`;

export const ProceedButton = styled(Button)`
  min-width: 251px;
  height: ${Spacings.SPACING_12B};
  border: none;
  &:disabled {
    background-color: var(--color-base-light-0);
    color: var(--color-text-secondary);
  }

  ${mediaQuery.uptoMobile} {
    width: 100%;
    min-width: unset;
  }
`;

export const ActionRow = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  ${mediaQuery.uptoMobile} {
    justify-content: stretch;
    position: sticky;
    bottom: 0;
    background-color: var(--color-base-1);
    padding-top: ${Spacings.SPACING_4B};
    margin-top: auto;
  }
`;

export const BannerStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_3B};
  width: 100%;
`;

export const WarningBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
  border-radius: ${Spacings.SPACING_2B};
  background-color: var(--color-bg-yellow);
  text-align: center;
`;

export const FeedbackBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
  border-radius: ${Spacings.SPACING_2B};
  background-color: var(--color-blue-bg);
`;

export const BannerText = styled(Typography)`
  font-size: ${Fonts.P2};
  line-height: ${Spacings.SPACING_6B};
  color: var(--color-text-primary);
`;

export const WarningText = styled(BannerText)`
  color: var(--color-yellow-1);
  text-align: center;
`;

export const FeedbackLink = styled.button`
  display: inline;
  padding: 0;
  border: none;
  background: none;
  color: var(--color-accent-blue);
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.P2};
  line-height: ${Spacings.SPACING_6B};
  cursor: pointer;
  text-decoration: underline;
`;
